<template>
  <el-dialog
    v-drag-dialog="drag"
    :title="title"
    :visible="isVisible"
    :close-on-click-modal="false"
    :before-close="beforeClose"
    @closed="closeDialog"
    :width="width"
    :top="top"
    :show-close="showClose"
    :append-to-body="appendToBody"
    :fullscreen="fullscreen"
  >
    <slot></slot>
    <slot name="footer" slot="footer"></slot>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: [Boolean],
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '850px'
    },
    top: String,
    appendToBody: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    drag: {
      type: Boolean,
      default: true
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isVisible: false
    };
  },
  watch: {
    visible(newVal) {
      this.$nextTick(() => {
        this.isVisible = newVal;
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isVisible = this.visible;
    });
  },
  methods: {
    // 关闭弹窗前
    beforeClose: function () {
      this.isVisible = false;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.$emit('close', false);
    }
  }
};
</script>

<style lang='scss'>
@import '@/style/colors.scss';
</style>
